'use strict';

export class ZipSearchLogic {
  /*@ngInject*/
  constructor() {
    this.ZipCodeJp = ZipCodeJp;
    this.ZipCodeJp.setZipCodeBaseUrl('/zip_code');
  }

  get(zipCode) {
    const zip = zipCode.replace(/(\d{3})-?(\d{4})/, '$1$2');

    return new Promise((resolve, reject) => {
      this.ZipCodeJp.getAddressesOfZipCode(zip, (err, addresses) => {
        if (err) {
          reject(err);
        }
        if (addresses.length === 0) {
          reject([]);
        }
        resolve(addresses[0]);
      });
    });
  }
}

export default angular.module('leptonApp.ZipSearchLogic', [])
  .service('ZipSearchLogic', [ZipSearchLogic])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/zip-search/zip-search.logic.js